const formatFiscalIdProgressively = (digits: string): string => {
  const length = digits.length

  switch (true) {
    case length <= 3:
      return digits
    case length <= 6:
      return `${digits.slice(0, 3)}.${digits.slice(3)}`
    case length <= 9:
      return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`
    case length <= 11:
      return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`
    case length <= 12:
      return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8)}`
    default:
      return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`
  }
}

export default formatFiscalIdProgressively
